module.exports = __webpack_public_path__ + "img/fuka3.e8066f5d.png";